import React from 'react';
import PropTypes from 'prop-types';
import ReviewCard from './ReviewCard';

const CustomerReviews = ({ reviews = [] }) => {
  if (reviews.length === 0) return null;

  const displayReviews = reviews;

  return (
    <div className="mt-[40px] md:my-[30px] mb-0 bg-white">
      <div className="w-full max-w-[604px] mx-auto">
        <div className="bg-white">
          <h3 className="text-base font-medium mb-4 text-[#1C1C1C]">Customer Reviews</h3>
          <div className="flex flex-col gap-[33px] bg-white">
            {displayReviews.map((review) => (
              <ReviewCard
                key={review.id}
                reviewer={review.reviewer}
                date={review.date}
                rating={review.rating}
                comment={review.comment}
                avatarUrl={review.avatarUrl}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

CustomerReviews.propTypes = {
  reviews: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      reviewer: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      rating: PropTypes.number.isRequired,
      comment: PropTypes.string.isRequired,
      avatarUrl: PropTypes.string.isRequired
    })
  )
};

export default CustomerReviews;
